export default __webpack_public_path__ + "static/media/UpdatedAIIconWithCircle.f7e8e08a.svg";